module.exports = __webpack_public_path__ + "img/thumbs_up_filled.5377248b.svg";